module.exports = __webpack_public_path__ + "img/plank.c90704ff.svg";